module.exports = __webpack_public_path__ + "img/button-block-icon.5c76ab62.svg";